import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { IdpGroupRolesBulkActionsConfirmActionStepProps } from "./types";

type IdpGroupRolesBulkActionsConfirmActionStepDefaultProps =
  IdpGroupRolesBulkActionsConfirmActionStepProps;

const IdpGroupRolesBulkActionsConfirmActionStepDefault = ({
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
}: IdpGroupRolesBulkActionsConfirmActionStepDefaultProps) => {
  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={() =>
        onConfirm(null, {
          view: bulkActionsVariant,
          metadata: {},
        })
      }
      onCancel={onCancel}
    />
  );
};

export default IdpGroupRolesBulkActionsConfirmActionStepDefault;
